export default "__VITE_ASSET__CIYuOLBv__"